import { render } from "./QuizGeneralSettings.vue?vue&type=template&id=a60620a0"
import script from "./QuizGeneralSettings.vue?vue&type=script&lang=js"
export * from "./QuizGeneralSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__